import { render, staticRenderFns } from "./FundDetail.vue?vue&type=template&id=47cd3f2d&scoped=true"
import script from "./FundDetail.vue?vue&type=script&lang=js"
export * from "./FundDetail.vue?vue&type=script&lang=js"
import style0 from "./FundDetail.vue?vue&type=style&index=0&id=47cd3f2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cd3f2d",
  null
  
)

export default component.exports